
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMessageActiveGoogle as ObiMessageActiveGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-message-active-google.js';
 
 
 

 
 export const ObiMessageActiveGoogle = createComponent({
   react: React,
   tagName: 'obi-message-active-google',
   elementClass: ObiMessageActiveGoogleElement,
   events: {
     
   }
  });
 
 